/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import type { CreateFileRoute, FileRoutesByPath } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AuthMinimalRouteImport } from './routes/_auth-minimal'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as SplatRouteImport } from './routes/$'
import { Route as PublicIndexRouteImport } from './routes/_public/index'
import { Route as PublicUnauthorizedRouteImport } from './routes/_public/unauthorized'
import { Route as PublicResetPasswordRouteImport } from './routes/_public/reset-password'
import { Route as PublicMagicLinkRouteImport } from './routes/_public/magic-link'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as PublicInvestorsRouteImport } from './routes/_public/investors'
import { Route as PublicForgotPasswordRouteImport } from './routes/_public/forgot-password'
import { Route as AuthAdminRouteImport } from './routes/_auth/admin'
import { Route as AuthMinimalPropertyUpdatesRouteImport } from './routes/_auth-minimal/property-updates'
import { Route as AuthMinimalOnboardingRouteImport } from './routes/_auth-minimal/onboarding'
import { Route as AuthMinimalAgreementRouteImport } from './routes/_auth-minimal/agreement'
import { Route as PublicRequestAccountIndexRouteImport } from './routes/_public/request-account/index'
import { Route as AuthSupportIndexRouteImport } from './routes/_auth/support/index'
import { Route as AuthPropertiesIndexRouteImport } from './routes/_auth/properties/index'
import { Route as AuthOffersIndexRouteImport } from './routes/_auth/offers/index'
import { Route as AuthBuyboxIndexRouteImport } from './routes/_auth/buybox/index'
import { Route as PublicRequestAccountSubmittedRouteImport } from './routes/_public/request-account/submitted'
import { Route as PublicRequestAccountFormRouteImport } from './routes/_public/request-account/form'
import { Route as PublicRequestAccountCheckEmailRouteImport } from './routes/_public/request-account/check-email'
import { Route as AuthSettingsProfileRouteImport } from './routes/_auth/settings/profile'
import { Route as AuthSettingsNotificationsRouteImport } from './routes/_auth/settings/notifications'
import { Route as AuthPropertiesCreateRouteImport } from './routes/_auth/properties/create'
import { Route as AuthBuyboxCreateRouteImport } from './routes/_auth/buybox/create'
import { Route as AuthAdminReportingRouteImport } from './routes/_auth/admin/reporting'
import { Route as AuthPropertiesIdIndexRouteImport } from './routes/_auth/properties/$id/index'
import { Route as AuthAdminUsersIndexRouteImport } from './routes/_auth/admin/users/index'
import { Route as AuthAdminReportingIndexRouteImport } from './routes/_auth/admin/reporting/index'
import { Route as AuthAdminPartnersIndexRouteImport } from './routes/_auth/admin/partners/index'
import { Route as AuthAdminAccountRequestsIndexRouteImport } from './routes/_auth/admin/account-requests/index'
import { Route as AuthPropertiesIdOffersRouteImport } from './routes/_auth/properties/$id/offers'
import { Route as AuthPropertiesIdOfferRouteImport } from './routes/_auth/properties/$id/offer'
import { Route as AuthPropertiesIdEditRouteImport } from './routes/_auth/properties/$id/edit'
import { Route as AuthPropertiesIdCounterRouteImport } from './routes/_auth/properties/$id/counter'
import { Route as AuthPropertiesIdAskRouteImport } from './routes/_auth/properties/$id/ask'
import { Route as AuthBuyboxIdEditRouteImport } from './routes/_auth/buybox/$id/edit'
import { Route as AuthAdminUsersNewRouteImport } from './routes/_auth/admin/users/new'
import { Route as AuthAdminUsersBulkUpdateRouteImport } from './routes/_auth/admin/users/bulk-update'
import { Route as AuthAdminUsersIdRouteImport } from './routes/_auth/admin/users/$id'
import { Route as AuthAdminReportingStaleOfferRemindersRouteImport } from './routes/_auth/admin/reporting/stale-offer-reminders'
import { Route as AuthAdminReportingInvestorsRouteImport } from './routes/_auth/admin/reporting/investors'
import { Route as AuthAdminReportingInvestorEngagementRouteImport } from './routes/_auth/admin/reporting/investor-engagement'
import { Route as AuthAdminReportingEmailRouteImport } from './routes/_auth/admin/reporting/email'
import { Route as AuthAdminReportingAgentsRouteImport } from './routes/_auth/admin/reporting/agents'
import { Route as AuthAdminPartnersPartnerIdRouteImport } from './routes/_auth/admin/partners/$partnerId'
import { Route as AuthAdminAccountRequestsIdRouteImport } from './routes/_auth/admin/account-requests/$id'
import { Route as AuthAdminReportingInvestorsIndexRouteImport } from './routes/_auth/admin/reporting/investors/index'
import { Route as AuthAdminReportingAgentsIndexRouteImport } from './routes/_auth/admin/reporting/agents/index'
import { Route as AuthAdminReportingInvestorsIdRouteImport } from './routes/_auth/admin/reporting/investors/$id'
import { Route as AuthAdminReportingAgentsIdRouteImport } from './routes/_auth/admin/reporting/agents/$id'
import { Route as AuthAdminReportingInvestorsIdIndexRouteImport } from './routes/_auth/admin/reporting/investors/$id/index'
import { Route as AuthAdminReportingAgentsIdIndexRouteImport } from './routes/_auth/admin/reporting/agents/$id/index'
import { Route as PublicPartnerSlugPropertiesPropertyIdOfferRouteImport } from './routes/_public/partner/$slug/properties/$propertyId/offer'
import { Route as AuthAdminReportingInvestorsIdAgreementRouteImport } from './routes/_auth/admin/reporting/investors/$id/agreement'
import { Route as AuthAdminReportingInvestorsIdActivityRouteImport } from './routes/_auth/admin/reporting/investors/$id/activity'

const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthMinimalRoute = AuthMinimalRouteImport.update({
  id: '/_auth-minimal',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicIndexRoute = PublicIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicUnauthorizedRoute = PublicUnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => PublicRoute,
} as any)
const PublicResetPasswordRoute = PublicResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => PublicRoute,
} as any)
const PublicMagicLinkRoute = PublicMagicLinkRouteImport.update({
  id: '/magic-link',
  path: '/magic-link',
  getParentRoute: () => PublicRoute,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any)
const PublicInvestorsRoute = PublicInvestorsRouteImport.update({
  id: '/investors',
  path: '/investors',
  getParentRoute: () => PublicRoute,
} as any)
const PublicForgotPasswordRoute = PublicForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => PublicRoute,
} as any)
const AuthAdminRoute = AuthAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMinimalPropertyUpdatesRoute =
  AuthMinimalPropertyUpdatesRouteImport.update({
    id: '/property-updates',
    path: '/property-updates',
    getParentRoute: () => AuthMinimalRoute,
  } as any)
const AuthMinimalOnboardingRoute = AuthMinimalOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AuthMinimalRoute,
} as any)
const AuthMinimalAgreementRoute = AuthMinimalAgreementRouteImport.update({
  id: '/agreement',
  path: '/agreement',
  getParentRoute: () => AuthMinimalRoute,
} as any)
const PublicRequestAccountIndexRoute =
  PublicRequestAccountIndexRouteImport.update({
    id: '/request-account/',
    path: '/request-account/',
    getParentRoute: () => PublicRoute,
  } as any)
const AuthSupportIndexRoute = AuthSupportIndexRouteImport.update({
  id: '/support/',
  path: '/support/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPropertiesIndexRoute = AuthPropertiesIndexRouteImport.update({
  id: '/properties/',
  path: '/properties/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOffersIndexRoute = AuthOffersIndexRouteImport.update({
  id: '/offers/',
  path: '/offers/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBuyboxIndexRoute = AuthBuyboxIndexRouteImport.update({
  id: '/buybox/',
  path: '/buybox/',
  getParentRoute: () => AuthRoute,
} as any)
const PublicRequestAccountSubmittedRoute =
  PublicRequestAccountSubmittedRouteImport.update({
    id: '/request-account/submitted',
    path: '/request-account/submitted',
    getParentRoute: () => PublicRoute,
  } as any)
const PublicRequestAccountFormRoute =
  PublicRequestAccountFormRouteImport.update({
    id: '/request-account/form',
    path: '/request-account/form',
    getParentRoute: () => PublicRoute,
  } as any)
const PublicRequestAccountCheckEmailRoute =
  PublicRequestAccountCheckEmailRouteImport.update({
    id: '/request-account/check-email',
    path: '/request-account/check-email',
    getParentRoute: () => PublicRoute,
  } as any)
const AuthSettingsProfileRoute = AuthSettingsProfileRouteImport.update({
  id: '/settings/profile',
  path: '/settings/profile',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsNotificationsRoute =
  AuthSettingsNotificationsRouteImport.update({
    id: '/settings/notifications',
    path: '/settings/notifications',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPropertiesCreateRoute = AuthPropertiesCreateRouteImport.update({
  id: '/properties/create',
  path: '/properties/create',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBuyboxCreateRoute = AuthBuyboxCreateRouteImport.update({
  id: '/buybox/create',
  path: '/buybox/create',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminReportingRoute = AuthAdminReportingRouteImport.update({
  id: '/reporting',
  path: '/reporting',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthPropertiesIdIndexRoute = AuthPropertiesIdIndexRouteImport.update({
  id: '/properties/$id/',
  path: '/properties/$id/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminUsersIndexRoute = AuthAdminUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminReportingIndexRoute = AuthAdminReportingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAdminReportingRoute,
} as any)
const AuthAdminPartnersIndexRoute = AuthAdminPartnersIndexRouteImport.update({
  id: '/partners/',
  path: '/partners/',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminAccountRequestsIndexRoute =
  AuthAdminAccountRequestsIndexRouteImport.update({
    id: '/account-requests/',
    path: '/account-requests/',
    getParentRoute: () => AuthAdminRoute,
  } as any)
const AuthPropertiesIdOffersRoute = AuthPropertiesIdOffersRouteImport.update({
  id: '/properties/$id/offers',
  path: '/properties/$id/offers',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPropertiesIdOfferRoute = AuthPropertiesIdOfferRouteImport.update({
  id: '/properties/$id/offer',
  path: '/properties/$id/offer',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPropertiesIdEditRoute = AuthPropertiesIdEditRouteImport.update({
  id: '/properties/$id/edit',
  path: '/properties/$id/edit',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPropertiesIdCounterRoute = AuthPropertiesIdCounterRouteImport.update({
  id: '/properties/$id/counter',
  path: '/properties/$id/counter',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPropertiesIdAskRoute = AuthPropertiesIdAskRouteImport.update({
  id: '/properties/$id/ask',
  path: '/properties/$id/ask',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBuyboxIdEditRoute = AuthBuyboxIdEditRouteImport.update({
  id: '/buybox/$id/edit',
  path: '/buybox/$id/edit',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminUsersNewRoute = AuthAdminUsersNewRouteImport.update({
  id: '/users/new',
  path: '/users/new',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminUsersBulkUpdateRoute =
  AuthAdminUsersBulkUpdateRouteImport.update({
    id: '/users/bulk-update',
    path: '/users/bulk-update',
    getParentRoute: () => AuthAdminRoute,
  } as any)
const AuthAdminUsersIdRoute = AuthAdminUsersIdRouteImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminReportingStaleOfferRemindersRoute =
  AuthAdminReportingStaleOfferRemindersRouteImport.update({
    id: '/stale-offer-reminders',
    path: '/stale-offer-reminders',
    getParentRoute: () => AuthAdminReportingRoute,
  } as any)
const AuthAdminReportingInvestorsRoute =
  AuthAdminReportingInvestorsRouteImport.update({
    id: '/investors',
    path: '/investors',
    getParentRoute: () => AuthAdminReportingRoute,
  } as any)
const AuthAdminReportingInvestorEngagementRoute =
  AuthAdminReportingInvestorEngagementRouteImport.update({
    id: '/investor-engagement',
    path: '/investor-engagement',
    getParentRoute: () => AuthAdminReportingRoute,
  } as any)
const AuthAdminReportingEmailRoute = AuthAdminReportingEmailRouteImport.update({
  id: '/email',
  path: '/email',
  getParentRoute: () => AuthAdminReportingRoute,
} as any)
const AuthAdminReportingAgentsRoute =
  AuthAdminReportingAgentsRouteImport.update({
    id: '/agents',
    path: '/agents',
    getParentRoute: () => AuthAdminReportingRoute,
  } as any)
const AuthAdminPartnersPartnerIdRoute =
  AuthAdminPartnersPartnerIdRouteImport.update({
    id: '/partners/$partnerId',
    path: '/partners/$partnerId',
    getParentRoute: () => AuthAdminRoute,
  } as any)
const AuthAdminAccountRequestsIdRoute =
  AuthAdminAccountRequestsIdRouteImport.update({
    id: '/account-requests/$id',
    path: '/account-requests/$id',
    getParentRoute: () => AuthAdminRoute,
  } as any)
const AuthAdminReportingInvestorsIndexRoute =
  AuthAdminReportingInvestorsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAdminReportingInvestorsRoute,
  } as any)
const AuthAdminReportingAgentsIndexRoute =
  AuthAdminReportingAgentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAdminReportingAgentsRoute,
  } as any)
const AuthAdminReportingInvestorsIdRoute =
  AuthAdminReportingInvestorsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthAdminReportingInvestorsRoute,
  } as any)
const AuthAdminReportingAgentsIdRoute =
  AuthAdminReportingAgentsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthAdminReportingAgentsRoute,
  } as any)
const AuthAdminReportingInvestorsIdIndexRoute =
  AuthAdminReportingInvestorsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAdminReportingInvestorsIdRoute,
  } as any)
const AuthAdminReportingAgentsIdIndexRoute =
  AuthAdminReportingAgentsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAdminReportingAgentsIdRoute,
  } as any)
const PublicPartnerSlugPropertiesPropertyIdOfferRoute =
  PublicPartnerSlugPropertiesPropertyIdOfferRouteImport.update({
    id: '/partner/$slug/properties/$propertyId/offer',
    path: '/partner/$slug/properties/$propertyId/offer',
    getParentRoute: () => PublicRoute,
  } as any)
const AuthAdminReportingInvestorsIdAgreementRoute =
  AuthAdminReportingInvestorsIdAgreementRouteImport.update({
    id: '/agreement',
    path: '/agreement',
    getParentRoute: () => AuthAdminReportingInvestorsIdRoute,
  } as any)
const AuthAdminReportingInvestorsIdActivityRoute =
  AuthAdminReportingInvestorsIdActivityRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => AuthAdminReportingInvestorsIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/$': typeof SplatRoute
  '/': typeof PublicIndexRoute
  '/agreement': typeof AuthMinimalAgreementRoute
  '/onboarding': typeof AuthMinimalOnboardingRoute
  '/property-updates': typeof AuthMinimalPropertyUpdatesRoute
  '/admin': typeof AuthAdminRouteWithChildren
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/investors': typeof PublicInvestorsRoute
  '/login': typeof PublicLoginRoute
  '/magic-link': typeof PublicMagicLinkRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/unauthorized': typeof PublicUnauthorizedRoute
  '/admin/reporting': typeof AuthAdminReportingRouteWithChildren
  '/buybox/create': typeof AuthBuyboxCreateRoute
  '/properties/create': typeof AuthPropertiesCreateRoute
  '/settings/notifications': typeof AuthSettingsNotificationsRoute
  '/settings/profile': typeof AuthSettingsProfileRoute
  '/request-account/check-email': typeof PublicRequestAccountCheckEmailRoute
  '/request-account/form': typeof PublicRequestAccountFormRoute
  '/request-account/submitted': typeof PublicRequestAccountSubmittedRoute
  '/buybox/': typeof AuthBuyboxIndexRoute
  '/offers/': typeof AuthOffersIndexRoute
  '/properties/': typeof AuthPropertiesIndexRoute
  '/support/': typeof AuthSupportIndexRoute
  '/request-account/': typeof PublicRequestAccountIndexRoute
  '/admin/account-requests/$id': typeof AuthAdminAccountRequestsIdRoute
  '/admin/partners/$partnerId': typeof AuthAdminPartnersPartnerIdRoute
  '/admin/reporting/agents': typeof AuthAdminReportingAgentsRouteWithChildren
  '/admin/reporting/email': typeof AuthAdminReportingEmailRoute
  '/admin/reporting/investor-engagement': typeof AuthAdminReportingInvestorEngagementRoute
  '/admin/reporting/investors': typeof AuthAdminReportingInvestorsRouteWithChildren
  '/admin/reporting/stale-offer-reminders': typeof AuthAdminReportingStaleOfferRemindersRoute
  '/admin/users/$id': typeof AuthAdminUsersIdRoute
  '/admin/users/bulk-update': typeof AuthAdminUsersBulkUpdateRoute
  '/admin/users/new': typeof AuthAdminUsersNewRoute
  '/buybox/$id/edit': typeof AuthBuyboxIdEditRoute
  '/properties/$id/ask': typeof AuthPropertiesIdAskRoute
  '/properties/$id/counter': typeof AuthPropertiesIdCounterRoute
  '/properties/$id/edit': typeof AuthPropertiesIdEditRoute
  '/properties/$id/offer': typeof AuthPropertiesIdOfferRoute
  '/properties/$id/offers': typeof AuthPropertiesIdOffersRoute
  '/admin/account-requests/': typeof AuthAdminAccountRequestsIndexRoute
  '/admin/partners/': typeof AuthAdminPartnersIndexRoute
  '/admin/reporting/': typeof AuthAdminReportingIndexRoute
  '/admin/users/': typeof AuthAdminUsersIndexRoute
  '/properties/$id/': typeof AuthPropertiesIdIndexRoute
  '/admin/reporting/agents/$id': typeof AuthAdminReportingAgentsIdRouteWithChildren
  '/admin/reporting/investors/$id': typeof AuthAdminReportingInvestorsIdRouteWithChildren
  '/admin/reporting/agents/': typeof AuthAdminReportingAgentsIndexRoute
  '/admin/reporting/investors/': typeof AuthAdminReportingInvestorsIndexRoute
  '/admin/reporting/investors/$id/activity': typeof AuthAdminReportingInvestorsIdActivityRoute
  '/admin/reporting/investors/$id/agreement': typeof AuthAdminReportingInvestorsIdAgreementRoute
  '/partner/$slug/properties/$propertyId/offer': typeof PublicPartnerSlugPropertiesPropertyIdOfferRoute
  '/admin/reporting/agents/$id/': typeof AuthAdminReportingAgentsIdIndexRoute
  '/admin/reporting/investors/$id/': typeof AuthAdminReportingInvestorsIdIndexRoute
}
export interface FileRoutesByTo {
  '/$': typeof SplatRoute
  '/': typeof PublicIndexRoute
  '/agreement': typeof AuthMinimalAgreementRoute
  '/onboarding': typeof AuthMinimalOnboardingRoute
  '/property-updates': typeof AuthMinimalPropertyUpdatesRoute
  '/admin': typeof AuthAdminRouteWithChildren
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/investors': typeof PublicInvestorsRoute
  '/login': typeof PublicLoginRoute
  '/magic-link': typeof PublicMagicLinkRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/unauthorized': typeof PublicUnauthorizedRoute
  '/buybox/create': typeof AuthBuyboxCreateRoute
  '/properties/create': typeof AuthPropertiesCreateRoute
  '/settings/notifications': typeof AuthSettingsNotificationsRoute
  '/settings/profile': typeof AuthSettingsProfileRoute
  '/request-account/check-email': typeof PublicRequestAccountCheckEmailRoute
  '/request-account/form': typeof PublicRequestAccountFormRoute
  '/request-account/submitted': typeof PublicRequestAccountSubmittedRoute
  '/buybox': typeof AuthBuyboxIndexRoute
  '/offers': typeof AuthOffersIndexRoute
  '/properties': typeof AuthPropertiesIndexRoute
  '/support': typeof AuthSupportIndexRoute
  '/request-account': typeof PublicRequestAccountIndexRoute
  '/admin/account-requests/$id': typeof AuthAdminAccountRequestsIdRoute
  '/admin/partners/$partnerId': typeof AuthAdminPartnersPartnerIdRoute
  '/admin/reporting/email': typeof AuthAdminReportingEmailRoute
  '/admin/reporting/investor-engagement': typeof AuthAdminReportingInvestorEngagementRoute
  '/admin/reporting/stale-offer-reminders': typeof AuthAdminReportingStaleOfferRemindersRoute
  '/admin/users/$id': typeof AuthAdminUsersIdRoute
  '/admin/users/bulk-update': typeof AuthAdminUsersBulkUpdateRoute
  '/admin/users/new': typeof AuthAdminUsersNewRoute
  '/buybox/$id/edit': typeof AuthBuyboxIdEditRoute
  '/properties/$id/ask': typeof AuthPropertiesIdAskRoute
  '/properties/$id/counter': typeof AuthPropertiesIdCounterRoute
  '/properties/$id/edit': typeof AuthPropertiesIdEditRoute
  '/properties/$id/offer': typeof AuthPropertiesIdOfferRoute
  '/properties/$id/offers': typeof AuthPropertiesIdOffersRoute
  '/admin/account-requests': typeof AuthAdminAccountRequestsIndexRoute
  '/admin/partners': typeof AuthAdminPartnersIndexRoute
  '/admin/reporting': typeof AuthAdminReportingIndexRoute
  '/admin/users': typeof AuthAdminUsersIndexRoute
  '/properties/$id': typeof AuthPropertiesIdIndexRoute
  '/admin/reporting/agents': typeof AuthAdminReportingAgentsIndexRoute
  '/admin/reporting/investors': typeof AuthAdminReportingInvestorsIndexRoute
  '/admin/reporting/investors/$id/activity': typeof AuthAdminReportingInvestorsIdActivityRoute
  '/admin/reporting/investors/$id/agreement': typeof AuthAdminReportingInvestorsIdAgreementRoute
  '/partner/$slug/properties/$propertyId/offer': typeof PublicPartnerSlugPropertiesPropertyIdOfferRoute
  '/admin/reporting/agents/$id': typeof AuthAdminReportingAgentsIdIndexRoute
  '/admin/reporting/investors/$id': typeof AuthAdminReportingInvestorsIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/$': typeof SplatRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_auth-minimal': typeof AuthMinimalRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_auth-minimal/agreement': typeof AuthMinimalAgreementRoute
  '/_auth-minimal/onboarding': typeof AuthMinimalOnboardingRoute
  '/_auth-minimal/property-updates': typeof AuthMinimalPropertyUpdatesRoute
  '/_auth/admin': typeof AuthAdminRouteWithChildren
  '/_public/forgot-password': typeof PublicForgotPasswordRoute
  '/_public/investors': typeof PublicInvestorsRoute
  '/_public/login': typeof PublicLoginRoute
  '/_public/magic-link': typeof PublicMagicLinkRoute
  '/_public/reset-password': typeof PublicResetPasswordRoute
  '/_public/unauthorized': typeof PublicUnauthorizedRoute
  '/_public/': typeof PublicIndexRoute
  '/_auth/admin/reporting': typeof AuthAdminReportingRouteWithChildren
  '/_auth/buybox/create': typeof AuthBuyboxCreateRoute
  '/_auth/properties/create': typeof AuthPropertiesCreateRoute
  '/_auth/settings/notifications': typeof AuthSettingsNotificationsRoute
  '/_auth/settings/profile': typeof AuthSettingsProfileRoute
  '/_public/request-account/check-email': typeof PublicRequestAccountCheckEmailRoute
  '/_public/request-account/form': typeof PublicRequestAccountFormRoute
  '/_public/request-account/submitted': typeof PublicRequestAccountSubmittedRoute
  '/_auth/buybox/': typeof AuthBuyboxIndexRoute
  '/_auth/offers/': typeof AuthOffersIndexRoute
  '/_auth/properties/': typeof AuthPropertiesIndexRoute
  '/_auth/support/': typeof AuthSupportIndexRoute
  '/_public/request-account/': typeof PublicRequestAccountIndexRoute
  '/_auth/admin/account-requests/$id': typeof AuthAdminAccountRequestsIdRoute
  '/_auth/admin/partners/$partnerId': typeof AuthAdminPartnersPartnerIdRoute
  '/_auth/admin/reporting/agents': typeof AuthAdminReportingAgentsRouteWithChildren
  '/_auth/admin/reporting/email': typeof AuthAdminReportingEmailRoute
  '/_auth/admin/reporting/investor-engagement': typeof AuthAdminReportingInvestorEngagementRoute
  '/_auth/admin/reporting/investors': typeof AuthAdminReportingInvestorsRouteWithChildren
  '/_auth/admin/reporting/stale-offer-reminders': typeof AuthAdminReportingStaleOfferRemindersRoute
  '/_auth/admin/users/$id': typeof AuthAdminUsersIdRoute
  '/_auth/admin/users/bulk-update': typeof AuthAdminUsersBulkUpdateRoute
  '/_auth/admin/users/new': typeof AuthAdminUsersNewRoute
  '/_auth/buybox/$id/edit': typeof AuthBuyboxIdEditRoute
  '/_auth/properties/$id/ask': typeof AuthPropertiesIdAskRoute
  '/_auth/properties/$id/counter': typeof AuthPropertiesIdCounterRoute
  '/_auth/properties/$id/edit': typeof AuthPropertiesIdEditRoute
  '/_auth/properties/$id/offer': typeof AuthPropertiesIdOfferRoute
  '/_auth/properties/$id/offers': typeof AuthPropertiesIdOffersRoute
  '/_auth/admin/account-requests/': typeof AuthAdminAccountRequestsIndexRoute
  '/_auth/admin/partners/': typeof AuthAdminPartnersIndexRoute
  '/_auth/admin/reporting/': typeof AuthAdminReportingIndexRoute
  '/_auth/admin/users/': typeof AuthAdminUsersIndexRoute
  '/_auth/properties/$id/': typeof AuthPropertiesIdIndexRoute
  '/_auth/admin/reporting/agents/$id': typeof AuthAdminReportingAgentsIdRouteWithChildren
  '/_auth/admin/reporting/investors/$id': typeof AuthAdminReportingInvestorsIdRouteWithChildren
  '/_auth/admin/reporting/agents/': typeof AuthAdminReportingAgentsIndexRoute
  '/_auth/admin/reporting/investors/': typeof AuthAdminReportingInvestorsIndexRoute
  '/_auth/admin/reporting/investors/$id/activity': typeof AuthAdminReportingInvestorsIdActivityRoute
  '/_auth/admin/reporting/investors/$id/agreement': typeof AuthAdminReportingInvestorsIdAgreementRoute
  '/_public/partner/$slug/properties/$propertyId/offer': typeof PublicPartnerSlugPropertiesPropertyIdOfferRoute
  '/_auth/admin/reporting/agents/$id/': typeof AuthAdminReportingAgentsIdIndexRoute
  '/_auth/admin/reporting/investors/$id/': typeof AuthAdminReportingInvestorsIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/$'
    | '/'
    | '/agreement'
    | '/onboarding'
    | '/property-updates'
    | '/admin'
    | '/forgot-password'
    | '/investors'
    | '/login'
    | '/magic-link'
    | '/reset-password'
    | '/unauthorized'
    | '/admin/reporting'
    | '/buybox/create'
    | '/properties/create'
    | '/settings/notifications'
    | '/settings/profile'
    | '/request-account/check-email'
    | '/request-account/form'
    | '/request-account/submitted'
    | '/buybox/'
    | '/offers/'
    | '/properties/'
    | '/support/'
    | '/request-account/'
    | '/admin/account-requests/$id'
    | '/admin/partners/$partnerId'
    | '/admin/reporting/agents'
    | '/admin/reporting/email'
    | '/admin/reporting/investor-engagement'
    | '/admin/reporting/investors'
    | '/admin/reporting/stale-offer-reminders'
    | '/admin/users/$id'
    | '/admin/users/bulk-update'
    | '/admin/users/new'
    | '/buybox/$id/edit'
    | '/properties/$id/ask'
    | '/properties/$id/counter'
    | '/properties/$id/edit'
    | '/properties/$id/offer'
    | '/properties/$id/offers'
    | '/admin/account-requests/'
    | '/admin/partners/'
    | '/admin/reporting/'
    | '/admin/users/'
    | '/properties/$id/'
    | '/admin/reporting/agents/$id'
    | '/admin/reporting/investors/$id'
    | '/admin/reporting/agents/'
    | '/admin/reporting/investors/'
    | '/admin/reporting/investors/$id/activity'
    | '/admin/reporting/investors/$id/agreement'
    | '/partner/$slug/properties/$propertyId/offer'
    | '/admin/reporting/agents/$id/'
    | '/admin/reporting/investors/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$'
    | '/'
    | '/agreement'
    | '/onboarding'
    | '/property-updates'
    | '/admin'
    | '/forgot-password'
    | '/investors'
    | '/login'
    | '/magic-link'
    | '/reset-password'
    | '/unauthorized'
    | '/buybox/create'
    | '/properties/create'
    | '/settings/notifications'
    | '/settings/profile'
    | '/request-account/check-email'
    | '/request-account/form'
    | '/request-account/submitted'
    | '/buybox'
    | '/offers'
    | '/properties'
    | '/support'
    | '/request-account'
    | '/admin/account-requests/$id'
    | '/admin/partners/$partnerId'
    | '/admin/reporting/email'
    | '/admin/reporting/investor-engagement'
    | '/admin/reporting/stale-offer-reminders'
    | '/admin/users/$id'
    | '/admin/users/bulk-update'
    | '/admin/users/new'
    | '/buybox/$id/edit'
    | '/properties/$id/ask'
    | '/properties/$id/counter'
    | '/properties/$id/edit'
    | '/properties/$id/offer'
    | '/properties/$id/offers'
    | '/admin/account-requests'
    | '/admin/partners'
    | '/admin/reporting'
    | '/admin/users'
    | '/properties/$id'
    | '/admin/reporting/agents'
    | '/admin/reporting/investors'
    | '/admin/reporting/investors/$id/activity'
    | '/admin/reporting/investors/$id/agreement'
    | '/partner/$slug/properties/$propertyId/offer'
    | '/admin/reporting/agents/$id'
    | '/admin/reporting/investors/$id'
  id:
    | '__root__'
    | '/$'
    | '/_auth'
    | '/_auth-minimal'
    | '/_public'
    | '/_auth-minimal/agreement'
    | '/_auth-minimal/onboarding'
    | '/_auth-minimal/property-updates'
    | '/_auth/admin'
    | '/_public/forgot-password'
    | '/_public/investors'
    | '/_public/login'
    | '/_public/magic-link'
    | '/_public/reset-password'
    | '/_public/unauthorized'
    | '/_public/'
    | '/_auth/admin/reporting'
    | '/_auth/buybox/create'
    | '/_auth/properties/create'
    | '/_auth/settings/notifications'
    | '/_auth/settings/profile'
    | '/_public/request-account/check-email'
    | '/_public/request-account/form'
    | '/_public/request-account/submitted'
    | '/_auth/buybox/'
    | '/_auth/offers/'
    | '/_auth/properties/'
    | '/_auth/support/'
    | '/_public/request-account/'
    | '/_auth/admin/account-requests/$id'
    | '/_auth/admin/partners/$partnerId'
    | '/_auth/admin/reporting/agents'
    | '/_auth/admin/reporting/email'
    | '/_auth/admin/reporting/investor-engagement'
    | '/_auth/admin/reporting/investors'
    | '/_auth/admin/reporting/stale-offer-reminders'
    | '/_auth/admin/users/$id'
    | '/_auth/admin/users/bulk-update'
    | '/_auth/admin/users/new'
    | '/_auth/buybox/$id/edit'
    | '/_auth/properties/$id/ask'
    | '/_auth/properties/$id/counter'
    | '/_auth/properties/$id/edit'
    | '/_auth/properties/$id/offer'
    | '/_auth/properties/$id/offers'
    | '/_auth/admin/account-requests/'
    | '/_auth/admin/partners/'
    | '/_auth/admin/reporting/'
    | '/_auth/admin/users/'
    | '/_auth/properties/$id/'
    | '/_auth/admin/reporting/agents/$id'
    | '/_auth/admin/reporting/investors/$id'
    | '/_auth/admin/reporting/agents/'
    | '/_auth/admin/reporting/investors/'
    | '/_auth/admin/reporting/investors/$id/activity'
    | '/_auth/admin/reporting/investors/$id/agreement'
    | '/_public/partner/$slug/properties/$propertyId/offer'
    | '/_auth/admin/reporting/agents/$id/'
    | '/_auth/admin/reporting/investors/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  SplatRoute: typeof SplatRoute
  AuthRoute: typeof AuthRouteWithChildren
  AuthMinimalRoute: typeof AuthMinimalRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth-minimal': {
      id: '/_auth-minimal'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthMinimalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/': {
      id: '/_public/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PublicIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/unauthorized': {
      id: '/_public/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof PublicUnauthorizedRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/reset-password': {
      id: '/_public/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof PublicResetPasswordRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/magic-link': {
      id: '/_public/magic-link'
      path: '/magic-link'
      fullPath: '/magic-link'
      preLoaderRoute: typeof PublicMagicLinkRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/investors': {
      id: '/_public/investors'
      path: '/investors'
      fullPath: '/investors'
      preLoaderRoute: typeof PublicInvestorsRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/forgot-password': {
      id: '/_public/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof PublicForgotPasswordRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_auth/admin': {
      id: '/_auth/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthAdminRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth-minimal/property-updates': {
      id: '/_auth-minimal/property-updates'
      path: '/property-updates'
      fullPath: '/property-updates'
      preLoaderRoute: typeof AuthMinimalPropertyUpdatesRouteImport
      parentRoute: typeof AuthMinimalRoute
    }
    '/_auth-minimal/onboarding': {
      id: '/_auth-minimal/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthMinimalOnboardingRouteImport
      parentRoute: typeof AuthMinimalRoute
    }
    '/_auth-minimal/agreement': {
      id: '/_auth-minimal/agreement'
      path: '/agreement'
      fullPath: '/agreement'
      preLoaderRoute: typeof AuthMinimalAgreementRouteImport
      parentRoute: typeof AuthMinimalRoute
    }
    '/_public/request-account/': {
      id: '/_public/request-account/'
      path: '/request-account'
      fullPath: '/request-account/'
      preLoaderRoute: typeof PublicRequestAccountIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_auth/support/': {
      id: '/_auth/support/'
      path: '/support'
      fullPath: '/support/'
      preLoaderRoute: typeof AuthSupportIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/properties/': {
      id: '/_auth/properties/'
      path: '/properties'
      fullPath: '/properties/'
      preLoaderRoute: typeof AuthPropertiesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/offers/': {
      id: '/_auth/offers/'
      path: '/offers'
      fullPath: '/offers/'
      preLoaderRoute: typeof AuthOffersIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/buybox/': {
      id: '/_auth/buybox/'
      path: '/buybox'
      fullPath: '/buybox/'
      preLoaderRoute: typeof AuthBuyboxIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_public/request-account/submitted': {
      id: '/_public/request-account/submitted'
      path: '/request-account/submitted'
      fullPath: '/request-account/submitted'
      preLoaderRoute: typeof PublicRequestAccountSubmittedRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/request-account/form': {
      id: '/_public/request-account/form'
      path: '/request-account/form'
      fullPath: '/request-account/form'
      preLoaderRoute: typeof PublicRequestAccountFormRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/request-account/check-email': {
      id: '/_public/request-account/check-email'
      path: '/request-account/check-email'
      fullPath: '/request-account/check-email'
      preLoaderRoute: typeof PublicRequestAccountCheckEmailRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_auth/settings/profile': {
      id: '/_auth/settings/profile'
      path: '/settings/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AuthSettingsProfileRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/notifications': {
      id: '/_auth/settings/notifications'
      path: '/settings/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthSettingsNotificationsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/properties/create': {
      id: '/_auth/properties/create'
      path: '/properties/create'
      fullPath: '/properties/create'
      preLoaderRoute: typeof AuthPropertiesCreateRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/buybox/create': {
      id: '/_auth/buybox/create'
      path: '/buybox/create'
      fullPath: '/buybox/create'
      preLoaderRoute: typeof AuthBuyboxCreateRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/reporting': {
      id: '/_auth/admin/reporting'
      path: '/reporting'
      fullPath: '/admin/reporting'
      preLoaderRoute: typeof AuthAdminReportingRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/properties/$id/': {
      id: '/_auth/properties/$id/'
      path: '/properties/$id'
      fullPath: '/properties/$id/'
      preLoaderRoute: typeof AuthPropertiesIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/users/': {
      id: '/_auth/admin/users/'
      path: '/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AuthAdminUsersIndexRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/reporting/': {
      id: '/_auth/admin/reporting/'
      path: '/'
      fullPath: '/admin/reporting/'
      preLoaderRoute: typeof AuthAdminReportingIndexRouteImport
      parentRoute: typeof AuthAdminReportingRoute
    }
    '/_auth/admin/partners/': {
      id: '/_auth/admin/partners/'
      path: '/partners'
      fullPath: '/admin/partners/'
      preLoaderRoute: typeof AuthAdminPartnersIndexRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/account-requests/': {
      id: '/_auth/admin/account-requests/'
      path: '/account-requests'
      fullPath: '/admin/account-requests/'
      preLoaderRoute: typeof AuthAdminAccountRequestsIndexRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/properties/$id/offers': {
      id: '/_auth/properties/$id/offers'
      path: '/properties/$id/offers'
      fullPath: '/properties/$id/offers'
      preLoaderRoute: typeof AuthPropertiesIdOffersRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/properties/$id/offer': {
      id: '/_auth/properties/$id/offer'
      path: '/properties/$id/offer'
      fullPath: '/properties/$id/offer'
      preLoaderRoute: typeof AuthPropertiesIdOfferRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/properties/$id/edit': {
      id: '/_auth/properties/$id/edit'
      path: '/properties/$id/edit'
      fullPath: '/properties/$id/edit'
      preLoaderRoute: typeof AuthPropertiesIdEditRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/properties/$id/counter': {
      id: '/_auth/properties/$id/counter'
      path: '/properties/$id/counter'
      fullPath: '/properties/$id/counter'
      preLoaderRoute: typeof AuthPropertiesIdCounterRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/properties/$id/ask': {
      id: '/_auth/properties/$id/ask'
      path: '/properties/$id/ask'
      fullPath: '/properties/$id/ask'
      preLoaderRoute: typeof AuthPropertiesIdAskRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/buybox/$id/edit': {
      id: '/_auth/buybox/$id/edit'
      path: '/buybox/$id/edit'
      fullPath: '/buybox/$id/edit'
      preLoaderRoute: typeof AuthBuyboxIdEditRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/users/new': {
      id: '/_auth/admin/users/new'
      path: '/users/new'
      fullPath: '/admin/users/new'
      preLoaderRoute: typeof AuthAdminUsersNewRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/users/bulk-update': {
      id: '/_auth/admin/users/bulk-update'
      path: '/users/bulk-update'
      fullPath: '/admin/users/bulk-update'
      preLoaderRoute: typeof AuthAdminUsersBulkUpdateRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/users/$id': {
      id: '/_auth/admin/users/$id'
      path: '/users/$id'
      fullPath: '/admin/users/$id'
      preLoaderRoute: typeof AuthAdminUsersIdRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/reporting/stale-offer-reminders': {
      id: '/_auth/admin/reporting/stale-offer-reminders'
      path: '/stale-offer-reminders'
      fullPath: '/admin/reporting/stale-offer-reminders'
      preLoaderRoute: typeof AuthAdminReportingStaleOfferRemindersRouteImport
      parentRoute: typeof AuthAdminReportingRoute
    }
    '/_auth/admin/reporting/investors': {
      id: '/_auth/admin/reporting/investors'
      path: '/investors'
      fullPath: '/admin/reporting/investors'
      preLoaderRoute: typeof AuthAdminReportingInvestorsRouteImport
      parentRoute: typeof AuthAdminReportingRoute
    }
    '/_auth/admin/reporting/investor-engagement': {
      id: '/_auth/admin/reporting/investor-engagement'
      path: '/investor-engagement'
      fullPath: '/admin/reporting/investor-engagement'
      preLoaderRoute: typeof AuthAdminReportingInvestorEngagementRouteImport
      parentRoute: typeof AuthAdminReportingRoute
    }
    '/_auth/admin/reporting/email': {
      id: '/_auth/admin/reporting/email'
      path: '/email'
      fullPath: '/admin/reporting/email'
      preLoaderRoute: typeof AuthAdminReportingEmailRouteImport
      parentRoute: typeof AuthAdminReportingRoute
    }
    '/_auth/admin/reporting/agents': {
      id: '/_auth/admin/reporting/agents'
      path: '/agents'
      fullPath: '/admin/reporting/agents'
      preLoaderRoute: typeof AuthAdminReportingAgentsRouteImport
      parentRoute: typeof AuthAdminReportingRoute
    }
    '/_auth/admin/partners/$partnerId': {
      id: '/_auth/admin/partners/$partnerId'
      path: '/partners/$partnerId'
      fullPath: '/admin/partners/$partnerId'
      preLoaderRoute: typeof AuthAdminPartnersPartnerIdRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/account-requests/$id': {
      id: '/_auth/admin/account-requests/$id'
      path: '/account-requests/$id'
      fullPath: '/admin/account-requests/$id'
      preLoaderRoute: typeof AuthAdminAccountRequestsIdRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/reporting/investors/': {
      id: '/_auth/admin/reporting/investors/'
      path: '/'
      fullPath: '/admin/reporting/investors/'
      preLoaderRoute: typeof AuthAdminReportingInvestorsIndexRouteImport
      parentRoute: typeof AuthAdminReportingInvestorsRoute
    }
    '/_auth/admin/reporting/agents/': {
      id: '/_auth/admin/reporting/agents/'
      path: '/'
      fullPath: '/admin/reporting/agents/'
      preLoaderRoute: typeof AuthAdminReportingAgentsIndexRouteImport
      parentRoute: typeof AuthAdminReportingAgentsRoute
    }
    '/_auth/admin/reporting/investors/$id': {
      id: '/_auth/admin/reporting/investors/$id'
      path: '/$id'
      fullPath: '/admin/reporting/investors/$id'
      preLoaderRoute: typeof AuthAdminReportingInvestorsIdRouteImport
      parentRoute: typeof AuthAdminReportingInvestorsRoute
    }
    '/_auth/admin/reporting/agents/$id': {
      id: '/_auth/admin/reporting/agents/$id'
      path: '/$id'
      fullPath: '/admin/reporting/agents/$id'
      preLoaderRoute: typeof AuthAdminReportingAgentsIdRouteImport
      parentRoute: typeof AuthAdminReportingAgentsRoute
    }
    '/_auth/admin/reporting/investors/$id/': {
      id: '/_auth/admin/reporting/investors/$id/'
      path: '/'
      fullPath: '/admin/reporting/investors/$id/'
      preLoaderRoute: typeof AuthAdminReportingInvestorsIdIndexRouteImport
      parentRoute: typeof AuthAdminReportingInvestorsIdRoute
    }
    '/_auth/admin/reporting/agents/$id/': {
      id: '/_auth/admin/reporting/agents/$id/'
      path: '/'
      fullPath: '/admin/reporting/agents/$id/'
      preLoaderRoute: typeof AuthAdminReportingAgentsIdIndexRouteImport
      parentRoute: typeof AuthAdminReportingAgentsIdRoute
    }
    '/_public/partner/$slug/properties/$propertyId/offer': {
      id: '/_public/partner/$slug/properties/$propertyId/offer'
      path: '/partner/$slug/properties/$propertyId/offer'
      fullPath: '/partner/$slug/properties/$propertyId/offer'
      preLoaderRoute: typeof PublicPartnerSlugPropertiesPropertyIdOfferRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_auth/admin/reporting/investors/$id/agreement': {
      id: '/_auth/admin/reporting/investors/$id/agreement'
      path: '/agreement'
      fullPath: '/admin/reporting/investors/$id/agreement'
      preLoaderRoute: typeof AuthAdminReportingInvestorsIdAgreementRouteImport
      parentRoute: typeof AuthAdminReportingInvestorsIdRoute
    }
    '/_auth/admin/reporting/investors/$id/activity': {
      id: '/_auth/admin/reporting/investors/$id/activity'
      path: '/activity'
      fullPath: '/admin/reporting/investors/$id/activity'
      preLoaderRoute: typeof AuthAdminReportingInvestorsIdActivityRouteImport
      parentRoute: typeof AuthAdminReportingInvestorsIdRoute
    }
  }
}

declare module './routes/$' {
  const createFileRoute: CreateFileRoute<
    '/$',
    FileRoutesByPath['/$']['parentRoute'],
    FileRoutesByPath['/$']['id'],
    FileRoutesByPath['/$']['path'],
    FileRoutesByPath['/$']['fullPath']
  >
}
declare module './routes/_auth' {
  const createFileRoute: CreateFileRoute<
    '/_auth',
    FileRoutesByPath['/_auth']['parentRoute'],
    FileRoutesByPath['/_auth']['id'],
    FileRoutesByPath['/_auth']['path'],
    FileRoutesByPath['/_auth']['fullPath']
  >
}
declare module './routes/_auth-minimal' {
  const createFileRoute: CreateFileRoute<
    '/_auth-minimal',
    FileRoutesByPath['/_auth-minimal']['parentRoute'],
    FileRoutesByPath['/_auth-minimal']['id'],
    FileRoutesByPath['/_auth-minimal']['path'],
    FileRoutesByPath['/_auth-minimal']['fullPath']
  >
}
declare module './routes/_public' {
  const createFileRoute: CreateFileRoute<
    '/_public',
    FileRoutesByPath['/_public']['parentRoute'],
    FileRoutesByPath['/_public']['id'],
    FileRoutesByPath['/_public']['path'],
    FileRoutesByPath['/_public']['fullPath']
  >
}
declare module './routes/_auth-minimal/agreement' {
  const createFileRoute: CreateFileRoute<
    '/_auth-minimal/agreement',
    FileRoutesByPath['/_auth-minimal/agreement']['parentRoute'],
    FileRoutesByPath['/_auth-minimal/agreement']['id'],
    FileRoutesByPath['/_auth-minimal/agreement']['path'],
    FileRoutesByPath['/_auth-minimal/agreement']['fullPath']
  >
}
declare module './routes/_auth-minimal/onboarding' {
  const createFileRoute: CreateFileRoute<
    '/_auth-minimal/onboarding',
    FileRoutesByPath['/_auth-minimal/onboarding']['parentRoute'],
    FileRoutesByPath['/_auth-minimal/onboarding']['id'],
    FileRoutesByPath['/_auth-minimal/onboarding']['path'],
    FileRoutesByPath['/_auth-minimal/onboarding']['fullPath']
  >
}
declare module './routes/_auth-minimal/property-updates' {
  const createFileRoute: CreateFileRoute<
    '/_auth-minimal/property-updates',
    FileRoutesByPath['/_auth-minimal/property-updates']['parentRoute'],
    FileRoutesByPath['/_auth-minimal/property-updates']['id'],
    FileRoutesByPath['/_auth-minimal/property-updates']['path'],
    FileRoutesByPath['/_auth-minimal/property-updates']['fullPath']
  >
}
declare module './routes/_auth/admin' {
  const createFileRoute: CreateFileRoute<
    '/_auth/admin',
    FileRoutesByPath['/_auth/admin']['parentRoute'],
    FileRoutesByPath['/_auth/admin']['id'],
    FileRoutesByPath['/_auth/admin']['path'],
    FileRoutesByPath['/_auth/admin']['fullPath']
  >
}
declare module './routes/_public/forgot-password' {
  const createFileRoute: CreateFileRoute<
    '/_public/forgot-password',
    FileRoutesByPath['/_public/forgot-password']['parentRoute'],
    FileRoutesByPath['/_public/forgot-password']['id'],
    FileRoutesByPath['/_public/forgot-password']['path'],
    FileRoutesByPath['/_public/forgot-password']['fullPath']
  >
}
declare module './routes/_public/investors' {
  const createFileRoute: CreateFileRoute<
    '/_public/investors',
    FileRoutesByPath['/_public/investors']['parentRoute'],
    FileRoutesByPath['/_public/investors']['id'],
    FileRoutesByPath['/_public/investors']['path'],
    FileRoutesByPath['/_public/investors']['fullPath']
  >
}
declare module './routes/_public/login' {
  const createFileRoute: CreateFileRoute<
    '/_public/login',
    FileRoutesByPath['/_public/login']['parentRoute'],
    FileRoutesByPath['/_public/login']['id'],
    FileRoutesByPath['/_public/login']['path'],
    FileRoutesByPath['/_public/login']['fullPath']
  >
}
declare module './routes/_public/magic-link' {
  const createFileRoute: CreateFileRoute<
    '/_public/magic-link',
    FileRoutesByPath['/_public/magic-link']['parentRoute'],
    FileRoutesByPath['/_public/magic-link']['id'],
    FileRoutesByPath['/_public/magic-link']['path'],
    FileRoutesByPath['/_public/magic-link']['fullPath']
  >
}
declare module './routes/_public/reset-password' {
  const createFileRoute: CreateFileRoute<
    '/_public/reset-password',
    FileRoutesByPath['/_public/reset-password']['parentRoute'],
    FileRoutesByPath['/_public/reset-password']['id'],
    FileRoutesByPath['/_public/reset-password']['path'],
    FileRoutesByPath['/_public/reset-password']['fullPath']
  >
}
declare module './routes/_public/unauthorized' {
  const createFileRoute: CreateFileRoute<
    '/_public/unauthorized',
    FileRoutesByPath['/_public/unauthorized']['parentRoute'],
    FileRoutesByPath['/_public/unauthorized']['id'],
    FileRoutesByPath['/_public/unauthorized']['path'],
    FileRoutesByPath['/_public/unauthorized']['fullPath']
  >
}
declare module './routes/_public/index' {
  const createFileRoute: CreateFileRoute<
    '/_public/',
    FileRoutesByPath['/_public/']['parentRoute'],
    FileRoutesByPath['/_public/']['id'],
    FileRoutesByPath['/_public/']['path'],
    FileRoutesByPath['/_public/']['fullPath']
  >
}
declare module './routes/_auth/admin/reporting' {
  const createFileRoute: CreateFileRoute<
    '/_auth/admin/reporting',
    FileRoutesByPath['/_auth/admin/reporting']['parentRoute'],
    FileRoutesByPath['/_auth/admin/reporting']['id'],
    FileRoutesByPath['/_auth/admin/reporting']['path'],
    FileRoutesByPath['/_auth/admin/reporting']['fullPath']
  >
}
declare module './routes/_auth/buybox/create' {
  const createFileRoute: CreateFileRoute<
    '/_auth/buybox/create',
    FileRoutesByPath['/_auth/buybox/create']['parentRoute'],
    FileRoutesByPath['/_auth/buybox/create']['id'],
    FileRoutesByPath['/_auth/buybox/create']['path'],
    FileRoutesByPath['/_auth/buybox/create']['fullPath']
  >
}
declare module './routes/_auth/properties/create' {
  const createFileRoute: CreateFileRoute<
    '/_auth/properties/create',
    FileRoutesByPath['/_auth/properties/create']['parentRoute'],
    FileRoutesByPath['/_auth/properties/create']['id'],
    FileRoutesByPath['/_auth/properties/create']['path'],
    FileRoutesByPath['/_auth/properties/create']['fullPath']
  >
}
declare module './routes/_auth/settings/notifications' {
  const createFileRoute: CreateFileRoute<
    '/_auth/settings/notifications',
    FileRoutesByPath['/_auth/settings/notifications']['parentRoute'],
    FileRoutesByPath['/_auth/settings/notifications']['id'],
    FileRoutesByPath['/_auth/settings/notifications']['path'],
    FileRoutesByPath['/_auth/settings/notifications']['fullPath']
  >
}
declare module './routes/_auth/settings/profile' {
  const createFileRoute: CreateFileRoute<
    '/_auth/settings/profile',
    FileRoutesByPath['/_auth/settings/profile']['parentRoute'],
    FileRoutesByPath['/_auth/settings/profile']['id'],
    FileRoutesByPath['/_auth/settings/profile']['path'],
    FileRoutesByPath['/_auth/settings/profile']['fullPath']
  >
}
declare module './routes/_public/request-account/check-email' {
  const createFileRoute: CreateFileRoute<
    '/_public/request-account/check-email',
    FileRoutesByPath['/_public/request-account/check-email']['parentRoute'],
    FileRoutesByPath['/_public/request-account/check-email']['id'],
    FileRoutesByPath['/_public/request-account/check-email']['path'],
    FileRoutesByPath['/_public/request-account/check-email']['fullPath']
  >
}
declare module './routes/_public/request-account/form' {
  const createFileRoute: CreateFileRoute<
    '/_public/request-account/form',
    FileRoutesByPath['/_public/request-account/form']['parentRoute'],
    FileRoutesByPath['/_public/request-account/form']['id'],
    FileRoutesByPath['/_public/request-account/form']['path'],
    FileRoutesByPath['/_public/request-account/form']['fullPath']
  >
}
declare module './routes/_public/request-account/submitted' {
  const createFileRoute: CreateFileRoute<
    '/_public/request-account/submitted',
    FileRoutesByPath['/_public/request-account/submitted']['parentRoute'],
    FileRoutesByPath['/_public/request-account/submitted']['id'],
    FileRoutesByPath['/_public/request-account/submitted']['path'],
    FileRoutesByPath['/_public/request-account/submitted']['fullPath']
  >
}
declare module './routes/_auth/buybox/index' {
  const createFileRoute: CreateFileRoute<
    '/_auth/buybox/',
    FileRoutesByPath['/_auth/buybox/']['parentRoute'],
    FileRoutesByPath['/_auth/buybox/']['id'],
    FileRoutesByPath['/_auth/buybox/']['path'],
    FileRoutesByPath['/_auth/buybox/']['fullPath']
  >
}
declare module './routes/_auth/offers/index' {
  const createFileRoute: CreateFileRoute<
    '/_auth/offers/',
    FileRoutesByPath['/_auth/offers/']['parentRoute'],
    FileRoutesByPath['/_auth/offers/']['id'],
    FileRoutesByPath['/_auth/offers/']['path'],
    FileRoutesByPath['/_auth/offers/']['fullPath']
  >
}
declare module './routes/_auth/properties/index' {
  const createFileRoute: CreateFileRoute<
    '/_auth/properties/',
    FileRoutesByPath['/_auth/properties/']['parentRoute'],
    FileRoutesByPath['/_auth/properties/']['id'],
    FileRoutesByPath['/_auth/properties/']['path'],
    FileRoutesByPath['/_auth/properties/']['fullPath']
  >
}
declare module './routes/_auth/support/index' {
  const createFileRoute: CreateFileRoute<
    '/_auth/support/',
    FileRoutesByPath['/_auth/support/']['parentRoute'],
    FileRoutesByPath['/_auth/support/']['id'],
    FileRoutesByPath['/_auth/support/']['path'],
    FileRoutesByPath['/_auth/support/']['fullPath']
  >
}
declare module './routes/_public/request-account/index' {
  const createFileRoute: CreateFileRoute<
    '/_public/request-account/',
    FileRoutesByPath['/_public/request-account/']['parentRoute'],
    FileRoutesByPath['/_public/request-account/']['id'],
    FileRoutesByPath['/_public/request-account/']['path'],
    FileRoutesByPath['/_public/request-account/']['fullPath']
  >
}
declare module './routes/_auth/admin/account-requests/$id' {
  const createFileRoute: CreateFileRoute<
    '/_auth/admin/account-requests/$id',
    FileRoutesByPath['/_auth/admin/account-requests/$id']['parentRoute'],
    FileRoutesByPath['/_auth/admin/account-requests/$id']['id'],
    FileRoutesByPath['/_auth/admin/account-requests/$id']['path'],
    FileRoutesByPath['/_auth/admin/account-requests/$id']['fullPath']
  >
}
declare module './routes/_auth/admin/partners/$partnerId' {
  const createFileRoute: CreateFileRoute<
    '/_auth/admin/partners/$partnerId',
    FileRoutesByPath['/_auth/admin/partners/$partnerId']['parentRoute'],
    FileRoutesByPath['/_auth/admin/partners/$partnerId']['id'],
    FileRoutesByPath['/_auth/admin/partners/$partnerId']['path'],
    FileRoutesByPath['/_auth/admin/partners/$partnerId']['fullPath']
  >
}
declare module './routes/_auth/admin/reporting/agents' {
  const createFileRoute: CreateFileRoute<
    '/_auth/admin/reporting/agents',
    FileRoutesByPath['/_auth/admin/reporting/agents']['parentRoute'],
    FileRoutesByPath['/_auth/admin/reporting/agents']['id'],
    FileRoutesByPath['/_auth/admin/reporting/agents']['path'],
    FileRoutesByPath['/_auth/admin/reporting/agents']['fullPath']
  >
}
declare module './routes/_auth/admin/reporting/email' {
  const createFileRoute: CreateFileRoute<
    '/_auth/admin/reporting/email',
    FileRoutesByPath['/_auth/admin/reporting/email']['parentRoute'],
    FileRoutesByPath['/_auth/admin/reporting/email']['id'],
    FileRoutesByPath['/_auth/admin/reporting/email']['path'],
    FileRoutesByPath['/_auth/admin/reporting/email']['fullPath']
  >
}
declare module './routes/_auth/admin/reporting/investor-engagement' {
  const createFileRoute: CreateFileRoute<
    '/_auth/admin/reporting/investor-engagement',
    FileRoutesByPath['/_auth/admin/reporting/investor-engagement']['parentRoute'],
    FileRoutesByPath['/_auth/admin/reporting/investor-engagement']['id'],
    FileRoutesByPath['/_auth/admin/reporting/investor-engagement']['path'],
    FileRoutesByPath['/_auth/admin/reporting/investor-engagement']['fullPath']
  >
}
declare module './routes/_auth/admin/reporting/investors' {
  const createFileRoute: CreateFileRoute<
    '/_auth/admin/reporting/investors',
    FileRoutesByPath['/_auth/admin/reporting/investors']['parentRoute'],
    FileRoutesByPath['/_auth/admin/reporting/investors']['id'],
    FileRoutesByPath['/_auth/admin/reporting/investors']['path'],
    FileRoutesByPath['/_auth/admin/reporting/investors']['fullPath']
  >
}
declare module './routes/_auth/admin/reporting/stale-offer-reminders' {
  const createFileRoute: CreateFileRoute<
    '/_auth/admin/reporting/stale-offer-reminders',
    FileRoutesByPath['/_auth/admin/reporting/stale-offer-reminders']['parentRoute'],
    FileRoutesByPath['/_auth/admin/reporting/stale-offer-reminders']['id'],
    FileRoutesByPath['/_auth/admin/reporting/stale-offer-reminders']['path'],
    FileRoutesByPath['/_auth/admin/reporting/stale-offer-reminders']['fullPath']
  >
}
declare module './routes/_auth/admin/users/$id' {
  const createFileRoute: CreateFileRoute<
    '/_auth/admin/users/$id',
    FileRoutesByPath['/_auth/admin/users/$id']['parentRoute'],
    FileRoutesByPath['/_auth/admin/users/$id']['id'],
    FileRoutesByPath['/_auth/admin/users/$id']['path'],
    FileRoutesByPath['/_auth/admin/users/$id']['fullPath']
  >
}
declare module './routes/_auth/admin/users/bulk-update' {
  const createFileRoute: CreateFileRoute<
    '/_auth/admin/users/bulk-update',
    FileRoutesByPath['/_auth/admin/users/bulk-update']['parentRoute'],
    FileRoutesByPath['/_auth/admin/users/bulk-update']['id'],
    FileRoutesByPath['/_auth/admin/users/bulk-update']['path'],
    FileRoutesByPath['/_auth/admin/users/bulk-update']['fullPath']
  >
}
declare module './routes/_auth/admin/users/new' {
  const createFileRoute: CreateFileRoute<
    '/_auth/admin/users/new',
    FileRoutesByPath['/_auth/admin/users/new']['parentRoute'],
    FileRoutesByPath['/_auth/admin/users/new']['id'],
    FileRoutesByPath['/_auth/admin/users/new']['path'],
    FileRoutesByPath['/_auth/admin/users/new']['fullPath']
  >
}
declare module './routes/_auth/buybox/$id/edit' {
  const createFileRoute: CreateFileRoute<
    '/_auth/buybox/$id/edit',
    FileRoutesByPath['/_auth/buybox/$id/edit']['parentRoute'],
    FileRoutesByPath['/_auth/buybox/$id/edit']['id'],
    FileRoutesByPath['/_auth/buybox/$id/edit']['path'],
    FileRoutesByPath['/_auth/buybox/$id/edit']['fullPath']
  >
}
declare module './routes/_auth/properties/$id/ask' {
  const createFileRoute: CreateFileRoute<
    '/_auth/properties/$id/ask',
    FileRoutesByPath['/_auth/properties/$id/ask']['parentRoute'],
    FileRoutesByPath['/_auth/properties/$id/ask']['id'],
    FileRoutesByPath['/_auth/properties/$id/ask']['path'],
    FileRoutesByPath['/_auth/properties/$id/ask']['fullPath']
  >
}
declare module './routes/_auth/properties/$id/counter' {
  const createFileRoute: CreateFileRoute<
    '/_auth/properties/$id/counter',
    FileRoutesByPath['/_auth/properties/$id/counter']['parentRoute'],
    FileRoutesByPath['/_auth/properties/$id/counter']['id'],
    FileRoutesByPath['/_auth/properties/$id/counter']['path'],
    FileRoutesByPath['/_auth/properties/$id/counter']['fullPath']
  >
}
declare module './routes/_auth/properties/$id/edit' {
  const createFileRoute: CreateFileRoute<
    '/_auth/properties/$id/edit',
    FileRoutesByPath['/_auth/properties/$id/edit']['parentRoute'],
    FileRoutesByPath['/_auth/properties/$id/edit']['id'],
    FileRoutesByPath['/_auth/properties/$id/edit']['path'],
    FileRoutesByPath['/_auth/properties/$id/edit']['fullPath']
  >
}
declare module './routes/_auth/properties/$id/offer' {
  const createFileRoute: CreateFileRoute<
    '/_auth/properties/$id/offer',
    FileRoutesByPath['/_auth/properties/$id/offer']['parentRoute'],
    FileRoutesByPath['/_auth/properties/$id/offer']['id'],
    FileRoutesByPath['/_auth/properties/$id/offer']['path'],
    FileRoutesByPath['/_auth/properties/$id/offer']['fullPath']
  >
}
declare module './routes/_auth/properties/$id/offers' {
  const createFileRoute: CreateFileRoute<
    '/_auth/properties/$id/offers',
    FileRoutesByPath['/_auth/properties/$id/offers']['parentRoute'],
    FileRoutesByPath['/_auth/properties/$id/offers']['id'],
    FileRoutesByPath['/_auth/properties/$id/offers']['path'],
    FileRoutesByPath['/_auth/properties/$id/offers']['fullPath']
  >
}
declare module './routes/_auth/admin/account-requests/index' {
  const createFileRoute: CreateFileRoute<
    '/_auth/admin/account-requests/',
    FileRoutesByPath['/_auth/admin/account-requests/']['parentRoute'],
    FileRoutesByPath['/_auth/admin/account-requests/']['id'],
    FileRoutesByPath['/_auth/admin/account-requests/']['path'],
    FileRoutesByPath['/_auth/admin/account-requests/']['fullPath']
  >
}
declare module './routes/_auth/admin/partners/index' {
  const createFileRoute: CreateFileRoute<
    '/_auth/admin/partners/',
    FileRoutesByPath['/_auth/admin/partners/']['parentRoute'],
    FileRoutesByPath['/_auth/admin/partners/']['id'],
    FileRoutesByPath['/_auth/admin/partners/']['path'],
    FileRoutesByPath['/_auth/admin/partners/']['fullPath']
  >
}
declare module './routes/_auth/admin/reporting/index' {
  const createFileRoute: CreateFileRoute<
    '/_auth/admin/reporting/',
    FileRoutesByPath['/_auth/admin/reporting/']['parentRoute'],
    FileRoutesByPath['/_auth/admin/reporting/']['id'],
    FileRoutesByPath['/_auth/admin/reporting/']['path'],
    FileRoutesByPath['/_auth/admin/reporting/']['fullPath']
  >
}
declare module './routes/_auth/admin/users/index' {
  const createFileRoute: CreateFileRoute<
    '/_auth/admin/users/',
    FileRoutesByPath['/_auth/admin/users/']['parentRoute'],
    FileRoutesByPath['/_auth/admin/users/']['id'],
    FileRoutesByPath['/_auth/admin/users/']['path'],
    FileRoutesByPath['/_auth/admin/users/']['fullPath']
  >
}
declare module './routes/_auth/properties/$id/index' {
  const createFileRoute: CreateFileRoute<
    '/_auth/properties/$id/',
    FileRoutesByPath['/_auth/properties/$id/']['parentRoute'],
    FileRoutesByPath['/_auth/properties/$id/']['id'],
    FileRoutesByPath['/_auth/properties/$id/']['path'],
    FileRoutesByPath['/_auth/properties/$id/']['fullPath']
  >
}
declare module './routes/_auth/admin/reporting/agents/$id' {
  const createFileRoute: CreateFileRoute<
    '/_auth/admin/reporting/agents/$id',
    FileRoutesByPath['/_auth/admin/reporting/agents/$id']['parentRoute'],
    FileRoutesByPath['/_auth/admin/reporting/agents/$id']['id'],
    FileRoutesByPath['/_auth/admin/reporting/agents/$id']['path'],
    FileRoutesByPath['/_auth/admin/reporting/agents/$id']['fullPath']
  >
}
declare module './routes/_auth/admin/reporting/investors/$id' {
  const createFileRoute: CreateFileRoute<
    '/_auth/admin/reporting/investors/$id',
    FileRoutesByPath['/_auth/admin/reporting/investors/$id']['parentRoute'],
    FileRoutesByPath['/_auth/admin/reporting/investors/$id']['id'],
    FileRoutesByPath['/_auth/admin/reporting/investors/$id']['path'],
    FileRoutesByPath['/_auth/admin/reporting/investors/$id']['fullPath']
  >
}
declare module './routes/_auth/admin/reporting/agents/index' {
  const createFileRoute: CreateFileRoute<
    '/_auth/admin/reporting/agents/',
    FileRoutesByPath['/_auth/admin/reporting/agents/']['parentRoute'],
    FileRoutesByPath['/_auth/admin/reporting/agents/']['id'],
    FileRoutesByPath['/_auth/admin/reporting/agents/']['path'],
    FileRoutesByPath['/_auth/admin/reporting/agents/']['fullPath']
  >
}
declare module './routes/_auth/admin/reporting/investors/index' {
  const createFileRoute: CreateFileRoute<
    '/_auth/admin/reporting/investors/',
    FileRoutesByPath['/_auth/admin/reporting/investors/']['parentRoute'],
    FileRoutesByPath['/_auth/admin/reporting/investors/']['id'],
    FileRoutesByPath['/_auth/admin/reporting/investors/']['path'],
    FileRoutesByPath['/_auth/admin/reporting/investors/']['fullPath']
  >
}
declare module './routes/_auth/admin/reporting/investors/$id/activity' {
  const createFileRoute: CreateFileRoute<
    '/_auth/admin/reporting/investors/$id/activity',
    FileRoutesByPath['/_auth/admin/reporting/investors/$id/activity']['parentRoute'],
    FileRoutesByPath['/_auth/admin/reporting/investors/$id/activity']['id'],
    FileRoutesByPath['/_auth/admin/reporting/investors/$id/activity']['path'],
    FileRoutesByPath['/_auth/admin/reporting/investors/$id/activity']['fullPath']
  >
}
declare module './routes/_auth/admin/reporting/investors/$id/agreement' {
  const createFileRoute: CreateFileRoute<
    '/_auth/admin/reporting/investors/$id/agreement',
    FileRoutesByPath['/_auth/admin/reporting/investors/$id/agreement']['parentRoute'],
    FileRoutesByPath['/_auth/admin/reporting/investors/$id/agreement']['id'],
    FileRoutesByPath['/_auth/admin/reporting/investors/$id/agreement']['path'],
    FileRoutesByPath['/_auth/admin/reporting/investors/$id/agreement']['fullPath']
  >
}
declare module './routes/_public/partner/$slug/properties/$propertyId/offer' {
  const createFileRoute: CreateFileRoute<
    '/_public/partner/$slug/properties/$propertyId/offer',
    FileRoutesByPath['/_public/partner/$slug/properties/$propertyId/offer']['parentRoute'],
    FileRoutesByPath['/_public/partner/$slug/properties/$propertyId/offer']['id'],
    FileRoutesByPath['/_public/partner/$slug/properties/$propertyId/offer']['path'],
    FileRoutesByPath['/_public/partner/$slug/properties/$propertyId/offer']['fullPath']
  >
}
declare module './routes/_auth/admin/reporting/agents/$id/index' {
  const createFileRoute: CreateFileRoute<
    '/_auth/admin/reporting/agents/$id/',
    FileRoutesByPath['/_auth/admin/reporting/agents/$id/']['parentRoute'],
    FileRoutesByPath['/_auth/admin/reporting/agents/$id/']['id'],
    FileRoutesByPath['/_auth/admin/reporting/agents/$id/']['path'],
    FileRoutesByPath['/_auth/admin/reporting/agents/$id/']['fullPath']
  >
}
declare module './routes/_auth/admin/reporting/investors/$id/index' {
  const createFileRoute: CreateFileRoute<
    '/_auth/admin/reporting/investors/$id/',
    FileRoutesByPath['/_auth/admin/reporting/investors/$id/']['parentRoute'],
    FileRoutesByPath['/_auth/admin/reporting/investors/$id/']['id'],
    FileRoutesByPath['/_auth/admin/reporting/investors/$id/']['path'],
    FileRoutesByPath['/_auth/admin/reporting/investors/$id/']['fullPath']
  >
}

interface AuthAdminReportingAgentsIdRouteChildren {
  AuthAdminReportingAgentsIdIndexRoute: typeof AuthAdminReportingAgentsIdIndexRoute
}

const AuthAdminReportingAgentsIdRouteChildren: AuthAdminReportingAgentsIdRouteChildren =
  {
    AuthAdminReportingAgentsIdIndexRoute: AuthAdminReportingAgentsIdIndexRoute,
  }

const AuthAdminReportingAgentsIdRouteWithChildren =
  AuthAdminReportingAgentsIdRoute._addFileChildren(
    AuthAdminReportingAgentsIdRouteChildren,
  )

interface AuthAdminReportingAgentsRouteChildren {
  AuthAdminReportingAgentsIdRoute: typeof AuthAdminReportingAgentsIdRouteWithChildren
  AuthAdminReportingAgentsIndexRoute: typeof AuthAdminReportingAgentsIndexRoute
}

const AuthAdminReportingAgentsRouteChildren: AuthAdminReportingAgentsRouteChildren =
  {
    AuthAdminReportingAgentsIdRoute:
      AuthAdminReportingAgentsIdRouteWithChildren,
    AuthAdminReportingAgentsIndexRoute: AuthAdminReportingAgentsIndexRoute,
  }

const AuthAdminReportingAgentsRouteWithChildren =
  AuthAdminReportingAgentsRoute._addFileChildren(
    AuthAdminReportingAgentsRouteChildren,
  )

interface AuthAdminReportingInvestorsIdRouteChildren {
  AuthAdminReportingInvestorsIdActivityRoute: typeof AuthAdminReportingInvestorsIdActivityRoute
  AuthAdminReportingInvestorsIdAgreementRoute: typeof AuthAdminReportingInvestorsIdAgreementRoute
  AuthAdminReportingInvestorsIdIndexRoute: typeof AuthAdminReportingInvestorsIdIndexRoute
}

const AuthAdminReportingInvestorsIdRouteChildren: AuthAdminReportingInvestorsIdRouteChildren =
  {
    AuthAdminReportingInvestorsIdActivityRoute:
      AuthAdminReportingInvestorsIdActivityRoute,
    AuthAdminReportingInvestorsIdAgreementRoute:
      AuthAdminReportingInvestorsIdAgreementRoute,
    AuthAdminReportingInvestorsIdIndexRoute:
      AuthAdminReportingInvestorsIdIndexRoute,
  }

const AuthAdminReportingInvestorsIdRouteWithChildren =
  AuthAdminReportingInvestorsIdRoute._addFileChildren(
    AuthAdminReportingInvestorsIdRouteChildren,
  )

interface AuthAdminReportingInvestorsRouteChildren {
  AuthAdminReportingInvestorsIdRoute: typeof AuthAdminReportingInvestorsIdRouteWithChildren
  AuthAdminReportingInvestorsIndexRoute: typeof AuthAdminReportingInvestorsIndexRoute
}

const AuthAdminReportingInvestorsRouteChildren: AuthAdminReportingInvestorsRouteChildren =
  {
    AuthAdminReportingInvestorsIdRoute:
      AuthAdminReportingInvestorsIdRouteWithChildren,
    AuthAdminReportingInvestorsIndexRoute:
      AuthAdminReportingInvestorsIndexRoute,
  }

const AuthAdminReportingInvestorsRouteWithChildren =
  AuthAdminReportingInvestorsRoute._addFileChildren(
    AuthAdminReportingInvestorsRouteChildren,
  )

interface AuthAdminReportingRouteChildren {
  AuthAdminReportingAgentsRoute: typeof AuthAdminReportingAgentsRouteWithChildren
  AuthAdminReportingEmailRoute: typeof AuthAdminReportingEmailRoute
  AuthAdminReportingInvestorEngagementRoute: typeof AuthAdminReportingInvestorEngagementRoute
  AuthAdminReportingInvestorsRoute: typeof AuthAdminReportingInvestorsRouteWithChildren
  AuthAdminReportingStaleOfferRemindersRoute: typeof AuthAdminReportingStaleOfferRemindersRoute
  AuthAdminReportingIndexRoute: typeof AuthAdminReportingIndexRoute
}

const AuthAdminReportingRouteChildren: AuthAdminReportingRouteChildren = {
  AuthAdminReportingAgentsRoute: AuthAdminReportingAgentsRouteWithChildren,
  AuthAdminReportingEmailRoute: AuthAdminReportingEmailRoute,
  AuthAdminReportingInvestorEngagementRoute:
    AuthAdminReportingInvestorEngagementRoute,
  AuthAdminReportingInvestorsRoute:
    AuthAdminReportingInvestorsRouteWithChildren,
  AuthAdminReportingStaleOfferRemindersRoute:
    AuthAdminReportingStaleOfferRemindersRoute,
  AuthAdminReportingIndexRoute: AuthAdminReportingIndexRoute,
}

const AuthAdminReportingRouteWithChildren =
  AuthAdminReportingRoute._addFileChildren(AuthAdminReportingRouteChildren)

interface AuthAdminRouteChildren {
  AuthAdminReportingRoute: typeof AuthAdminReportingRouteWithChildren
  AuthAdminAccountRequestsIdRoute: typeof AuthAdminAccountRequestsIdRoute
  AuthAdminPartnersPartnerIdRoute: typeof AuthAdminPartnersPartnerIdRoute
  AuthAdminUsersIdRoute: typeof AuthAdminUsersIdRoute
  AuthAdminUsersBulkUpdateRoute: typeof AuthAdminUsersBulkUpdateRoute
  AuthAdminUsersNewRoute: typeof AuthAdminUsersNewRoute
  AuthAdminAccountRequestsIndexRoute: typeof AuthAdminAccountRequestsIndexRoute
  AuthAdminPartnersIndexRoute: typeof AuthAdminPartnersIndexRoute
  AuthAdminUsersIndexRoute: typeof AuthAdminUsersIndexRoute
}

const AuthAdminRouteChildren: AuthAdminRouteChildren = {
  AuthAdminReportingRoute: AuthAdminReportingRouteWithChildren,
  AuthAdminAccountRequestsIdRoute: AuthAdminAccountRequestsIdRoute,
  AuthAdminPartnersPartnerIdRoute: AuthAdminPartnersPartnerIdRoute,
  AuthAdminUsersIdRoute: AuthAdminUsersIdRoute,
  AuthAdminUsersBulkUpdateRoute: AuthAdminUsersBulkUpdateRoute,
  AuthAdminUsersNewRoute: AuthAdminUsersNewRoute,
  AuthAdminAccountRequestsIndexRoute: AuthAdminAccountRequestsIndexRoute,
  AuthAdminPartnersIndexRoute: AuthAdminPartnersIndexRoute,
  AuthAdminUsersIndexRoute: AuthAdminUsersIndexRoute,
}

const AuthAdminRouteWithChildren = AuthAdminRoute._addFileChildren(
  AuthAdminRouteChildren,
)

interface AuthRouteChildren {
  AuthAdminRoute: typeof AuthAdminRouteWithChildren
  AuthBuyboxCreateRoute: typeof AuthBuyboxCreateRoute
  AuthPropertiesCreateRoute: typeof AuthPropertiesCreateRoute
  AuthSettingsNotificationsRoute: typeof AuthSettingsNotificationsRoute
  AuthSettingsProfileRoute: typeof AuthSettingsProfileRoute
  AuthBuyboxIndexRoute: typeof AuthBuyboxIndexRoute
  AuthOffersIndexRoute: typeof AuthOffersIndexRoute
  AuthPropertiesIndexRoute: typeof AuthPropertiesIndexRoute
  AuthSupportIndexRoute: typeof AuthSupportIndexRoute
  AuthBuyboxIdEditRoute: typeof AuthBuyboxIdEditRoute
  AuthPropertiesIdAskRoute: typeof AuthPropertiesIdAskRoute
  AuthPropertiesIdCounterRoute: typeof AuthPropertiesIdCounterRoute
  AuthPropertiesIdEditRoute: typeof AuthPropertiesIdEditRoute
  AuthPropertiesIdOfferRoute: typeof AuthPropertiesIdOfferRoute
  AuthPropertiesIdOffersRoute: typeof AuthPropertiesIdOffersRoute
  AuthPropertiesIdIndexRoute: typeof AuthPropertiesIdIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAdminRoute: AuthAdminRouteWithChildren,
  AuthBuyboxCreateRoute: AuthBuyboxCreateRoute,
  AuthPropertiesCreateRoute: AuthPropertiesCreateRoute,
  AuthSettingsNotificationsRoute: AuthSettingsNotificationsRoute,
  AuthSettingsProfileRoute: AuthSettingsProfileRoute,
  AuthBuyboxIndexRoute: AuthBuyboxIndexRoute,
  AuthOffersIndexRoute: AuthOffersIndexRoute,
  AuthPropertiesIndexRoute: AuthPropertiesIndexRoute,
  AuthSupportIndexRoute: AuthSupportIndexRoute,
  AuthBuyboxIdEditRoute: AuthBuyboxIdEditRoute,
  AuthPropertiesIdAskRoute: AuthPropertiesIdAskRoute,
  AuthPropertiesIdCounterRoute: AuthPropertiesIdCounterRoute,
  AuthPropertiesIdEditRoute: AuthPropertiesIdEditRoute,
  AuthPropertiesIdOfferRoute: AuthPropertiesIdOfferRoute,
  AuthPropertiesIdOffersRoute: AuthPropertiesIdOffersRoute,
  AuthPropertiesIdIndexRoute: AuthPropertiesIdIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface AuthMinimalRouteChildren {
  AuthMinimalAgreementRoute: typeof AuthMinimalAgreementRoute
  AuthMinimalOnboardingRoute: typeof AuthMinimalOnboardingRoute
  AuthMinimalPropertyUpdatesRoute: typeof AuthMinimalPropertyUpdatesRoute
}

const AuthMinimalRouteChildren: AuthMinimalRouteChildren = {
  AuthMinimalAgreementRoute: AuthMinimalAgreementRoute,
  AuthMinimalOnboardingRoute: AuthMinimalOnboardingRoute,
  AuthMinimalPropertyUpdatesRoute: AuthMinimalPropertyUpdatesRoute,
}

const AuthMinimalRouteWithChildren = AuthMinimalRoute._addFileChildren(
  AuthMinimalRouteChildren,
)

interface PublicRouteChildren {
  PublicForgotPasswordRoute: typeof PublicForgotPasswordRoute
  PublicInvestorsRoute: typeof PublicInvestorsRoute
  PublicLoginRoute: typeof PublicLoginRoute
  PublicMagicLinkRoute: typeof PublicMagicLinkRoute
  PublicResetPasswordRoute: typeof PublicResetPasswordRoute
  PublicUnauthorizedRoute: typeof PublicUnauthorizedRoute
  PublicIndexRoute: typeof PublicIndexRoute
  PublicRequestAccountCheckEmailRoute: typeof PublicRequestAccountCheckEmailRoute
  PublicRequestAccountFormRoute: typeof PublicRequestAccountFormRoute
  PublicRequestAccountSubmittedRoute: typeof PublicRequestAccountSubmittedRoute
  PublicRequestAccountIndexRoute: typeof PublicRequestAccountIndexRoute
  PublicPartnerSlugPropertiesPropertyIdOfferRoute: typeof PublicPartnerSlugPropertiesPropertyIdOfferRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicForgotPasswordRoute: PublicForgotPasswordRoute,
  PublicInvestorsRoute: PublicInvestorsRoute,
  PublicLoginRoute: PublicLoginRoute,
  PublicMagicLinkRoute: PublicMagicLinkRoute,
  PublicResetPasswordRoute: PublicResetPasswordRoute,
  PublicUnauthorizedRoute: PublicUnauthorizedRoute,
  PublicIndexRoute: PublicIndexRoute,
  PublicRequestAccountCheckEmailRoute: PublicRequestAccountCheckEmailRoute,
  PublicRequestAccountFormRoute: PublicRequestAccountFormRoute,
  PublicRequestAccountSubmittedRoute: PublicRequestAccountSubmittedRoute,
  PublicRequestAccountIndexRoute: PublicRequestAccountIndexRoute,
  PublicPartnerSlugPropertiesPropertyIdOfferRoute:
    PublicPartnerSlugPropertiesPropertyIdOfferRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  SplatRoute: SplatRoute,
  AuthRoute: AuthRouteWithChildren,
  AuthMinimalRoute: AuthMinimalRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
